export var Mode;
(function (Mode) {
    Mode["Runtime"] = "runtime";
})(Mode || (Mode = {}));
